import {Component, inject, input, OnInit} from '@angular/core'
import {FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators} from '@angular/forms'
import {MatCheckbox} from '@angular/material/checkbox'
import {MatError, MatFormField, MatLabel} from '@angular/material/form-field'
import {MatIcon} from '@angular/material/icon'
import {MatInput} from '@angular/material/input'
import {FormatNumberDirective} from '@sparbanken-syd/sparbanken-syd-theme'
import {OrientationService} from '../../../services/orientation.service'
import {SavingsAccountService} from '../../../services/savings-account.service'

@Component({
  selector: 'spb-income',
  templateUrl: './income.component.html',
  styleUrl: '../kyc.component.scss',
  imports: [ReactiveFormsModule, MatCheckbox, MatFormField, MatLabel, MatInput, MatError, FormatNumberDirective, MatIcon]
})
export class IncomeComponent implements OnInit {
  public incomeForm = input.required<FormGroup>()
  public readonly orientationService = inject(OrientationService)
  protected readonly savingsAccountService = inject(SavingsAccountService)

  public ngOnInit(): void {
    this.incomeForm().addValidators(this.atLeastOneSourceValidator)
    this.incomeForm().updateValueAndValidity()
  }

  public onCheckboxChange(index: number, checked: boolean, formValue: string) {
    this.savingsAccountService.incomeOptions[index].checked = checked
    const control = this.incomeForm().controls[formValue]

    if (checked) {
      control.setValidators([Validators.required, Validators.min(0.1)])
    } else {
      control.setValue(null)
      control.clearValidators()
    }
    control.updateValueAndValidity()
    this.incomeForm().updateValueAndValidity()
  }

  private readonly atLeastOneSourceValidator: ValidatorFn = (): ValidationErrors | null => {
    const hasAtLeastOneChecked = this.savingsAccountService.incomeOptions.some(option => option.checked)

    return hasAtLeastOneChecked ? null : {atLeastOneRequired: true}
  }
}